import type { ReactElement, ReactNode } from 'react';
import { TabPanel as AriaTabPanel } from 'react-aria-components';
import cx from 'clsx';
import styles from './tab-panel.module.css';

export interface TabPanelProps {
  children?: ReactNode;
  tabId: string;
  className?: string;
  'data-testid'?: string;
}

export function TabPanel({ children, tabId, className, ...props }: TabPanelProps): ReactElement {
  return (
    <AriaTabPanel className={cx(styles['tab-panel'], className)} id={tabId} {...props}>
      {children}
    </AriaTabPanel>
  );
}
